/* MyInsurance Phase 0.15 - consolidated presentation route markers. */

/* ===== SOURCE: phase014-route.js ===== */
/* MyInsurance Phase 0.9-0.14 consolidated route marker. Presentation only. */
(function () {
  function syncConsolidatedRoutes() {
    var h = window.location.hash || '';
    var contracts = /^#\/(contracts?(?:\/|$)|contract_types(?:\/|$)|public_ins_types(?:\/|$)|internal_ins_types(?:\/|$))/.test(h);
    var claims = /^#\/claims?(?:\/|$)/.test(h);
    var admin = /^#\/(customers\/payments|brokers\/payments|companies\/payments|broker-free-items|company-free-items|transit_accounts|payments|invoices|billing|first-note|commissions)(?:\/|$)/.test(h);
    var reports = /^#\/(reports|reports_header)(?:\/|$)/.test(h);
    var config = /^#\/(settings|dictionaries|dictionary|payment_types|email_templates|translations|translation|ui_dev_info|change_log|changelog|logs)(?:\/|$)/.test(h);
    if (!document.body) return;
    document.body.classList.toggle('mi-route-contracts', contracts);
    document.body.classList.toggle('mi-route-claims', claims);
    document.body.classList.toggle('mi-route-administration', admin);
    document.body.classList.toggle('mi-route-reports', reports);
    document.body.classList.toggle('mi-route-configuration', config);
    document.body.classList.toggle('mi-route-phase014', contracts || claims || admin || reports || config);
  }
  window.addEventListener('hashchange', syncConsolidatedRoutes);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncConsolidatedRoutes);
  else syncConsolidatedRoutes();
})();

/* ===== SOURCE: phase06-client-route.js ===== */
/* Phase 0.6 route marker. Presentation only. */
(function () {
  function syncClientRouteClass() {
    var hash = window.location.hash || '';
    var active = /^#\/(customers(?:\/|$)|customer\/profile(?:\/|$))/.test(hash);
    if (document.body) document.body.classList.toggle('mi-route-customers', active);
  }
  window.addEventListener('hashchange', syncClientRouteClass);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncClientRouteClass);
  } else {
    syncClientRouteClass();
  }
})();

/* ===== SOURCE: phase08-route.js ===== */
/* MyInsurance Phase 0.8 route marker. Presentation only. */
(function () {
  function syncPhase08Route() {
    var h = window.location.hash || '';
    var active = /^#\/(requests(?:\/|$)|quotes(?:\/|$)|guaranty_types(?:\/|$))/.test(h);
    if (document.body) document.body.classList.toggle('mi-route-phase08', active);
  }
  window.addEventListener('hashchange', syncPhase08Route);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncPhase08Route);
  else syncPhase08Route();
})();

/* ===== SOURCE: phase07-route.js ===== */
/* MyInsurance Phase 0.7 route marker. Presentation only. */
(function () {
  function syncPhase07Route() {
    var h = window.location.hash || '';
    var broker = /^#\/(brokers(?:\/|$)|broker\/profile(?:\/|$))/.test(h);
    var company = /^#\/(company(?:\/|$)|companies(?:\/|$)|company_guaranties(?:\/|$))/.test(h);
    if (!document.body) return;
    document.body.classList.toggle('mi-route-brokers', broker);
    document.body.classList.toggle('mi-route-companies', company);
    document.body.classList.toggle('mi-route-phase07', broker || company);
  }
  window.addEventListener('hashchange', syncPhase07Route);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncPhase07Route);
  else syncPhase07Route();
})();

